module.exports = __webpack_public_path__ + "img/cs-ball.534297b8.svg";